const styles = theme => ({
    grow: {
        flexGrow: 1,
    },
    spacer: {
        padding: "8px",
    },
    blockContainer: {
        minHeight: "250px",
        backgroundColor: theme.palette.background.elevated,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6),
        color: theme.palette.text.primary
    },
    infoText: {
        color: theme.palette.text.secondary
    },
    infoLink: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        textDecoration: "inherit",
    }
});

export default styles;
